import React from 'react';
import { Col, Row } from 'react-bootstrap';
import FilterWrapper from './FilterWrapper.jsx';

const CategoryFilters = ({
  filtersData,
  selectedCategories,
  selectedFilters,
  onSelectFilter,
}) => {
  return (
    <React.Fragment>
      {filtersData.map(
        (c) =>
          selectedCategories[c.key] && (
            <Row className="m-b-12 m-t-12">
              <Col xs={2}>
                <h4 className="flex flex-align-center">
                  {c.icon}
                  <div className="m-l-8 m-t-2">{c.title}</div>
                </h4>
              </Col>
              <Col xs={10}>
                <Row>
                  {c.filters.map(
                    (f) =>
                      !f.hidden &&
                      selectedFilters[f.key] && (
                        <Col xs={4} key={f.key}>
                          <FilterWrapper
                            action={() => onSelectFilter(c.key, f.key)}
                          >
                            {f.component}
                          </FilterWrapper>
                        </Col>
                      )
                  )}
                </Row>
              </Col>
            </Row>
          )
      )}
    </React.Fragment>
  );
};

export default CategoryFilters;
